import React, { useEffect, useState } from 'react';
import { configureStore } from '@reduxjs/toolkit'

import {Form, notification} from 'antd';

import { Provider, useDispatch, useSelector} from 'react-redux';
import { reducers } from './store'; 
import { FormularioCadastroProdutosRow } from './formulario-cadastro-produtos-row';
import { FormularioCadastroProdutosModal } from './formulario-cadastro-produtos-modal';
import { newProduto } from './store/produto.domain';
import { atualizaFirstErrorField, atualizaProduto, dadosPadraoProduto } from './store/cadastro-produto.reducer';
import { useProduto } from '../useProduto';

const Barcoder = require('barcoder');
const {useForm} = Form;

const {success, error} = notification;




const FormularioCadastroProduto = (props) => {

    const {reducer} = reducers;
    let valorInicial  = dadosPadraoProduto ;
    
    console.log("initialValue=>",props.initialValue);
    if(props.initialValue){
        valorInicial = Object.assign({}, valorInicial, props.initialValue);
    }

    console.log("valorInicial=>",valorInicial);
    const store = configureStore({reducer, preloadedState: {
        produto: {
            produto: valorInicial,
            firstErrorField: ''
        }
    }});

    return <Provider store={store}>
            <FormularioCadastroProdutoOnStore {...props}></FormularioCadastroProdutoOnStore>
        </Provider>
}
 
const FormularioCadastroProdutoOnStore = (props)=> {
    const {type="default", getApi, onSave, onSaveFail, initialValue=false} = props;

    const [form] = useForm(); 

    const {salvaProduto, aplicaValidacao} = useProduto(getApi, form, Barcoder);
    const [salvando, setSalvando]  = useState(false);

    const {produto:dadosProduto} = useSelector(state => state.produto);
    const produto = newProduto(dadosProduto);
    const dispatch = useDispatch();

    // const {consultaPorcentagemAprxImpostos} = useProduto(props.getApi);

    //const {deveCalcularImpostos, setDeveCalcularImpostos} = useEffect(true)


    // const preenchePorcentagemAprxImpostos = async () => {
    //     const porcentagemAproximadaImpostos = await consultaPorcentagemAprxImpostos(dadosProduto, dadosProduto.ncm);
    //     const novosDadosProduto = Object.assign({}, dadosProduto, {porcentagemAproximadaImpostos});
    //     dispatch(atualizaProduto(novosDadosProduto));

    // }
    // useEffect(() => {
    //     if(produto.precisaPreencherImpostos()){
    //         preenchePorcentagemAprxImpostos();
    //     }
    // }, [dadosProduto]);

    

    const onSalvarHandle = async (evt)=> {
        setSalvando(true);
        
        const retorno = await salvaProduto(produto);
        setSalvando(false);
        if(!retorno.sucesso){

            const {tipoErro, data} = retorno;

            if(tipoErro == "FORM_VALIDATION"){
                const {firstErrorField} = data;
                dispatch(atualizaFirstErrorField({id: firstErrorField}))
                return; 
            } 


            
            if(onSaveFail){
                onSaveFail(retorno);
            } else {
                let description = `O Produto não pôde ser salvo. Tente novamente!`;
                if(tipoErro == "API_ERROR"){
                    const {data} = retorno;
                    const {response} = data;
                    const {data:dadosRetorno} = response;
                    if(dadosRetorno.erro && typeof dadosRetorno.erro == "string"){
                        description = `${dadosRetorno.erro}` ;
                    }
                }
                error({
                    message: "Oh Não!",
                    description
                })
            }
            return;
        } 
        const {data} = retorno;
        const produtoSalvo = Object.assign({},dadosProduto, data);

        dispatch(atualizaProduto(produtoSalvo));

        if(onSave){
            onSave(newProduto(produtoSalvo));
        } else {
            // envia mensagem de ok
            success({
                message: "Muito bem",
                description: `Produto "${produto.props.descricao}" salvo com sucesso`
            })
        }
        return;
        

    };


    // const iniciaValor = async ()=>{
    //     dispatch(atualizaProduto(initialValue));
    // }
    // useEffect(()=>{
    //     if(initialValue){
    //       iniciaValor();
    //     }
    // }, [true])

    // useEffect(()=> {
        
    form.setFieldsValue(Object.assign({},dadosProduto));

    // }, [dadosProduto]);

    
   

    

   

    const formValueChangeHandler = (changedValues, allValues)=> {

        produto.fillValue(changedValues);

        aplicaValidacao(produto);
        
        dispatch(atualizaProduto(produto.toPlainJson()));

    }


   

    
    if(type=="default"){
        return <FormularioCadastroProdutosRow salvando={salvando} formValueChangeHandler={formValueChangeHandler} {...props} form={form} onSalvar={onSalvarHandle}></FormularioCadastroProdutosRow>
        
    } else if(type=="modal"){
       
        return <FormularioCadastroProdutosModal salvando={salvando} formValueChangeHandler={formValueChangeHandler} {...props} form={form} onSalvar={onSalvarHandle}></FormularioCadastroProdutosModal>
    }
    return <>Type property is invalid for FormularioCadastroProduto</>
}

export {FormularioCadastroProduto};